module.exports = __webpack_public_path__ + "img/mightyBrowser.1968316d.svg";